(function () {

  'use strict';

  // **********************************
  //  Data that this directive needs
  // ----------------------------------
  //
  //

  function pxAddSiteManagers(
    GroupListPaging, GroupListService, $timeout, GroupListPOSTPaging, GroupFilterModel
  ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/sites/addSiteManagers/addSiteManagers.template.html',
      link: function (scope) {

        scope.groupListPaging = new GroupListPOSTPaging();
        scope.requestType = 'POST';
        scope.filtersList = new GroupFilterModel('SITE_MANAGEMENT').filters;
        scope.groupList = [];
        scope.selectedGroups = [];
        scope.noGroupSelected = true;
        var scrollEnd = null;
        var containerHeight = null;
        var customKeyBinding = false;
        scope.searchString = '';

        (function () {
          customKeyBinding = true;
          scope.groupListPaging.pagingCriteria.exclude = [scope.context.links.self.href];
        })();

        scope.getGroupListPaged = function () {
          getFirstGroupsPage();
        }

        function getFirstGroupsPage() {
          scope.groupListPaging.pagingCriteria.page = 0;
          scope.loadingPage = true;
          scope.groupList = [];

          GroupListService.getGroupListPagedByPost(scope.groupListPaging).then(function (response) {
            window.scrollTo(0, 0);
            scope.totalPages = response.page.totalPages;
            scope.groupList = response.list;
            scope.loadingPage = false;
          }).catch(function(error){});
        }

        // ADD THROTTLE TO THIS
        scope.textSearch = function () {
          scope.groupListPaging.pagingCriteria.match = scope.searchString;
          getFirstGroupsPage();
        }

        function getNextGroupsPage() {
          if (!scope.loadingPage && scope.totalPages > scope.groupListPaging.pagingCriteria.page + 1) {
            scope.loadingPage = true;
            scope.groupListPaging.pagingCriteria.page += 1;
            GroupListService.getGroupListPagedByPost(scope.groupListPaging).then(function (response) {
              if (response.list) {
                scope.groupList = scope.groupList.concat(response.list);
              }
              scope.loadingPage = false;
            }).catch(function(error){});
          }
        }

        angular.element('.pagination-content').on('scroll', function (event) {
          scrollEnd = event.currentTarget.clientHeight + event.currentTarget.scrollTop + 1;
          containerHeight = event.currentTarget.scrollHeight;

          if (!scope.loadingPage && scope.totalPages > scope.groupListPaging.pagingCriteria.page + 1) {
            if (scrollEnd > containerHeight) {
              $timeout(function () {
                getNextGroupsPage();
              }, 300)
            }
          }
        });

        scope.$on('$destroy', function () {
          angular.element('.pagination-content').off('scroll');
          customKeyBinding = false;
        });

        document.onkeydown = function (evt) {
          evt = evt || window.event;
          if (customKeyBinding) {
            switch (evt.keyCode) { // should use evt.key
              case 38: // arrow up
                evt.preventDefault();
                if (document.activeElement.previousElementSibling) {
                  document.activeElement.previousElementSibling.focus();
                }
                break;
              case 40: // arrow down
                evt.preventDefault();
                if (document.activeElement.nextElementSibling) {
                  document.activeElement.nextElementSibling.focus();
                }
                break;
            }
          }
        };

        // TODO ADD escape key close, and ctrl + s to save

        scope.toggleSelectGroup = function (event, group) {
          event.stopPropagation();
          event.preventDefault();

          if (!group.options.isSelected) {
            group.options.isSelected = true;
            scope.selectedGroups.push(group);
          } else {
            group.options.isSelected = false;
            scope.deselectGroup(event, group);
          }

          scope.noGroupSelected = scope.selectedGroups.length === 0;
        }

        scope.deselectGroup = function (event, group) {
          for (var i = 0; i < scope.selectedGroups.length; i++) {
            if (group.info._links.self.href === scope.selectedGroups[i].info._links.self.href) {
              scope.selectedGroups.splice(i, 1);
            }
          }
        }

        scope.closePopup = function () {
          scope.callback();
        }

        scope.addManagerToSite = function () {
          scope.context.addManagerGroupsToSite(scope.selectedGroups).then(function(response){}).catch(function(error){});
          scope.closePopup();
        }
      }
    };
  }

  pxAddSiteManagers.$inject = ['GroupListPaging', 'GroupListService', '$timeout', 'GroupListPOSTPaging', 'GroupFilterModel'];

  angular
    .module('printix-admin')
    .directive('pxAddSiteManagers', pxAddSiteManagers);

})();
